import { Modal, View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import type { ReactNode } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { TYPO } from '@/constants/typography';
import { RADIUS, FONT, SPACE } from '@/constants/designTokens';

interface Props {
  visible: boolean;
  onClose: () => void;
  title: string;
  content: string | ReactNode;
}

export default function InfoSheet({ visible, onClose, title, content }: Props) {
  const { theme } = useTheme();
  const c = theme.colors;

  return (
    <Modal
      visible={visible}
      animationType="slide"
      transparent={true}
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <TouchableOpacity style={styles.backdrop} activeOpacity={1} onPress={onClose} />
        <View style={[styles.sheet, { backgroundColor: c.surface }]}>
          <Text style={[styles.title, { color: c.text }]}>{title}</Text>
          {typeof content === 'string' ? (
            <Text style={[styles.body, { color: c.text }]}>{content}</Text>
          ) : (
            content
          )}
          <TouchableOpacity
            style={[styles.button, { backgroundColor: c.accent }]}
            onPress={onClose}
            activeOpacity={0.7}
          >
            <Text style={styles.buttonText}>GOT IT</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  sheet: {
    borderTopLeftRadius: RADIUS.xs * 2,
    borderTopRightRadius: RADIUS.xs * 2,
    padding: SPACE.lg,
    paddingBottom: SPACE.xl + 16,
    gap: SPACE.md,
  },
  title: {
    fontSize: FONT.xl,
    fontFamily: TYPO.heading.bold,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  body: {
    fontSize: FONT.base,
    fontFamily: TYPO.body.medium,
    lineHeight: 22,
  },
  button: {
    alignItems: 'center',
    paddingVertical: 14,
    borderRadius: RADIUS.xs,
    marginTop: SPACE.sm,
  },
  buttonText: {
    color: '#030303',
    fontSize: FONT.base,
    fontFamily: TYPO.heading.bold,
    letterSpacing: 1,
  },
});
